import home from 'modules/home';

new home();
